// extracted by mini-css-extract-plugin
export default {"prompt-main":"PromptSection_prompt-main__l+CCi","prompt":"PromptSection_prompt__njMXP","is-selected":"PromptSection_is-selected__stFhU","icon":"PromptSection_icon__1v4Og"};